import { render, staticRenderFns } from "./AlertaDeQtdSugestao.vue?vue&type=template&id=033794c2&scoped=true"
import script from "./AlertaDeQtdSugestao.vue?vue&type=script&lang=js"
export * from "./AlertaDeQtdSugestao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033794c2",
  null
  
)

export default component.exports